// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c645226f","297":"e848971c","306":"292de975","598":"aa9d4690","629":"4b3239b1","813":"c969987a","939":"a0e87459","979":"b6f1b3bc"}[chunkId] + ".chunk.js";
};